export const trainRouter = [
  {
    path: '',
    redirect: 'notice'
  },
  {
    path: 'index',
    meta: {
      title: '数据总览',
    },
    component: () => import('../views/train/page/index'),
  },
  {
    path: 'notice',
    meta: {
      title: '通知管理',
    },
    component: () => import('../views/train/page/notice'),
  },
  {
    path: 'noticeDetail',
    meta: {
      title: '通知详情',
    },
    component: () => import('../views/train/page/noticeDetail'),
  },
  {
    path: 'account',
    meta: {
      title: '帐号管理',
    },
    component: () => import('../views/train/page/account'),
  },
  {
    path: 'info',
    meta: {
      title: '机构信息',
    },
    component: () => import('../views/train/page/info'),
  },
  {
    path: 'exam',
    meta: {
      title: '考试管理',
    },
    component: () => import('../views/train/page/exam'),
  },
  {
    path: 'examDetail',
    meta: {
      title: '考试详情',
    },
    component: () => import('../views/train/page/examDetail'),
  },
  {
    path: 'invitationSign',
    meta: {
      title: '邀请报名',
    },
    component: () => import('../views/train/page/invitationSign'),
  },
  {
    path: 'examinee',
    meta: {
      title: '学生列表',
    },
    component: () => import('../views/train/page/examinee'),
  },
  {
    path: 'examineeDetail',
    meta: {
      title: '学生详情',
    },
    component: () => import('../views/train/page/examineeDetail'),
  },
  {
    path: 'userInfo',
    meta: {
      title: '个人中心',
    },
    component: () => import('../views/train/page/userInfo'),
  }
]